
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { myAccountMenu } from '@xt/client/dataSource/my/index'
import MyLayout from '../views/MyLayout/index.vue'

@Component({
  components: {
    MyLayout
  }
})
export default class extends Vue {
  menuKey: string = ''

  get myAccountMenu() {
    return myAccountMenu
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
